const ProductIndex = () => import('./views/ProductIndex.vue')
const ProductCreate = () => import('./views/ProductCreate.vue')
const ProductEdit = () => import('./views/ProductEdit.vue')

export default [
  {
    path: 'products',
    name: 'products.index',
    component: ProductIndex
  },
  {
    path: 'products/create',
    name: 'products.create',
    component: ProductCreate
  },
  {
    path: 'products/:productId(\\d+)',
    name: 'products.edit',
    component: ProductEdit
  }
]
